import HomeAboutSec from "../../Home/HomeAboutSec";
import IndustriesSec2 from "../IndustiresSec2/IndustriesSec2";
import IndustriesSec3 from "../IndustriesSec3/IndustriesSec3";
import AboutSec2 from "../../About/AboutSec2/AboutSec2";
import HomeCtaBanner from "../../Home/HomeCtaBanner/HomeCtaBanner";
import SEO from "../../../components/SEO";

export default function ProfessionalService({ currentLanguage = "en" }) {
  const pageTitles = {
    en: "Professional Services",
    fr: "Services professionnels",
  };

  const pageTitle = pageTitles[currentLanguage] || pageTitles.en;

  return (
    <>
      <SEO title={pageTitle} />
      <HomeAboutSec currentLanguage={currentLanguage} />
      <IndustriesSec3 currentLanguage={currentLanguage} />
      <AboutSec2 currentLanguage={currentLanguage} />
      <IndustriesSec2 currentLanguage={currentLanguage} />
      <HomeCtaBanner currentLanguage={currentLanguage} />
    </>
  );
}
